import {Injectable, signal} from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class FileCardActionStateService {
  private _isActionState = signal<boolean>(false);
  private _currentFIleIdState = signal<number>(0);
  public isActionState = this._isActionState.asReadonly();
  public currentFIleIdState = this._currentFIleIdState.asReadonly();

  public setActionState(isActions: boolean, id: number): void {
    this._isActionState.set(isActions);
    this._currentFIleIdState.set(id);
  }

  public resetActionState(): void {
    this._isActionState.set(false);
    this._currentFIleIdState.set(0);
  }
}
